(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-game-card/prescript.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-game-card/prescript.js');

svs = svs || {};
svs.components = svs.components || {};
svs.components.casino_react = svs.components.casino_react || {};
svs.components.casino_react.casinoGameCard = svs.components.casino_react.casinoGameCard || {};


 })(window);